import React from 'react'

/**
 * Generic card container.
 *
 * Props:
 *   - variant: 'default' | 'readonly' | 'emphasised'
 *   - padding: 'sm' (14) | 'md' (16, default) | 'lg' (20)
 *   - as: tag or component (default 'div')
 */
export function Card({
  variant = 'default',
  padding = 'md',
  as: Tag = 'div',
  className = '',
  style,
  children,
  ...rest
}) {
  const variantClass = variant === 'default' ? '' : `card--${variant}`
  const classes = ['card', variantClass, className].filter(Boolean).join(' ')
  const padPx = padding === 'sm' ? 14 : padding === 'lg' ? 20 : 16
  return (
    <Tag className={classes} style={{ padding: padPx, ...style }} {...rest}>
      {children}
    </Tag>
  )
}
